export default __webpack_public_path__ + "cf1f6c842a1ec0af6b00ce1859dce6d5.js";